import api from './api.json';
import auth from './auth.json';
import bnpl from './bnpl.json';
import bookings from './bookings.json';
import common from './common.json';
import coupons from './coupons.json';
import createLink from './create-link.json';
import createproduct from './create-product.json';
import dashboard from './dashboard.json';
import discountSchedule from './discount-schedule.json';
import landingpage from './landing-page.json';
import marketplace from './marketplace.json';
import notification from './notification.json';
import operations from './operations.json';
import pageTitles from './page-titles.json';
import payout from './payout.json';
import productDetails from './product-details.json';
import productsList from './products-list.json';
import profile from './profile.json';
import reviews from './reviews.json';
import roles from './roles.json';
import seats from './seats.json';
import stoch from './stoch.json';
import tutorial from './tutorial.json';
import validation from './validation.json';
import visasManager from './visas-manager.json';
import wallet from './wallet.json';
import webpage from './webpage.json';
import onboard from './onboard.json';

const data = {
   common,
   validation,
   dashboard,
   createproduct,
   profile,
   auth,
   bookings,
   productsList,
   productDetails,
   createLink,
   payout,
   notification,
   reviews,
   operations,
   roles,
   marketplace,
   wallet,
   landingpage,
   pageTitles,
   stoch,
   api,
   seats,
   coupons,
   webpage,
   discountSchedule,
   tutorial,
   bnpl,
   visasManager,
   onboard,
};

export type TranslationShape = typeof data;

export default data;
